/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_QInputs */



/**
* | output |
* | --- |
* | "What kind of event is it?" |
*
* @param {Tournament_Wiz_Kind_QInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_q = /** @type {((inputs?: Tournament_Wiz_Kind_QInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_QInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("De quel type d'événement s'agit-il ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué tipo de evento es?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Que tipo de evento é?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Che tipo di evento è?")
	return /** @type {LocalizedString} */ ("What kind of event is it?")
});